import React from 'react'
import { IconFavoriteOutlined, IconFavoriteFilled } from 'components/Zui/Icon'
import { icons } from 'app/constants'
import FallackImage from './FallbackImage'
import Image from './Image'
import Video from './Video'
import Skeleton from './Skeleton'
import { Checkbox } from 'components/Zui'
import './index.css'

const index = ({
    isLoading,
    selectable = true,
    onSelect,
    onFavorite,
    isFavorite,
    isSelected,
    id,
    time,
    icons: headerIcons,
    fileType,
    url,
    onClick,
}) => {
    return (
        <div className="thumbnail-wrapper">
            <div className="thumbnail-container">
                {!isLoading && (
                    <div className={`thumbnail-header ${isSelected && 'selected'}`}>
                        <div className="thumbnail-header-details">
                            {selectable && (
                                <Checkbox
                                    theme="zbds-dark"
                                    value={isSelected}
                                    onChange={e => onSelect(e.target.value, id)}
                                    style={{ height: '16px', width: '16px', marginRight: '4px' }}
                                />
                            )}
                            {time && (
                                <div className="time-wrap" style={{ marginRight: '4px' }}>
                                    <span>{time}</span>
                                </div>
                            )}
                            {headerIcons &&
                                headerIcons.length > 0 &&
                                headerIcons.map(icn => {
                                    const ICON = icons[icn]
                                    return (
                                        ICON && (
                                            <ICON
                                                key={icn}
                                                size="s"
                                                className="thumbnail-icon-light"
                                            />
                                        )
                                    )
                                })}
                        </div>
                        {onFavorite && (
                            <div className="thumbnail-favourite-section">
                                {!isFavorite ? (
                                    <IconFavoriteOutlined
                                        className="thumbnail-icon-light-white"
                                        onClick={onFavorite}
                                    />
                                ) : (
                                    <IconFavoriteFilled
                                        className="thumbnail-icon-light-white"
                                        onClick={onFavorite}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                )}
                {isLoading && <Skeleton />}
                {!fileType && !isLoading && <FallackImage onClick={onClick} />}
                {fileType === 'image' && !isLoading && <Image imgUrl={url} onClick={onClick} />}
                {fileType === 'video' && !isLoading && <Video imgUrl={url} onClick={onClick} />}
            </div>
        </div>
    )
}

export default index
